import {Location} from '@angular/common';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, Effect, ofType} from '@ngrx/effects';
import {map, tap} from 'rxjs/operators';

import {GoAction, ReplaceAction, routerActions} from '../actions/router';

@Injectable()
export class RouterEffects {


  // tslint:disable-next-line:no-any
  navigate$: any = createEffect((): any => { return this.actions$
    .pipe(
      ofType(routerActions.GO),
      map((action: GoAction) => action.payload),
      tap(({path, query: queryParams, extras}) => {
        const extra = {queryParams, ...extras};
        this.router.navigate(path, extra);
      }),
    )}, { dispatch: false });


  // tslint:disable-next-line:no-any
  replace$: any = createEffect((): any => { return this.actions$
    .pipe(
      ofType(routerActions.REPLACE),
      map((action: ReplaceAction) => action.payload),
      tap(({path, query: queryParams, extras}) => this.router.navigate(path, {queryParams, ...extras, replaceUrl: true})),
    )}, { dispatch: false });


  // tslint:disable-next-line:no-any
  navigateBack$: any = createEffect((): any => { return this.actions$.pipe(
    ofType(routerActions.BACK),
    tap(() => this.location.back())
  )}, { dispatch: false });


  // tslint:disable-next-line:no-any
  navigateForward$: any = createEffect((): any => { return this.actions$.pipe(
    ofType(routerActions.FORWARD),
    tap(() => this.location.forward())
  )
  }, { dispatch: false });

  constructor(private actions$: Actions, private router: Router, private location: Location) {
  }
}
